// extracted by mini-css-extract-plugin
module.exports = {"PageContainer":"Layout_PageContainer__3mTJP","PageContainerFull":"Layout_PageContainerFull__3dwJC","contentContainer":"Layout_contentContainer__2pmlL"};